import * as Sentry from '@sentry/browser';
import { Layout } from 'antd';
import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import { AdminApp } from 'app/components/AdminApp';
import { ExtApp } from 'app/components/ExtApp';
import { HotelApp } from 'app/components/HotelApp';
import { HotelMigrationApp } from 'app/components/HotelMigrationApp';
import { PublicApp } from 'app/components/PublicApp';
import { ConfigContextProvider } from 'app/context/ConfigContext/ConfigContext';
import { UserContextProvider } from 'app/context/UserContext/UserContext';
import { useAuth } from 'app/hooks/data/auth/useAuth';
import { env, isDevelopment } from 'app/utils/env';

import 'styles/app.scss';

export const App: React.FC = () => {
  const { user, token } = useAuth(env.appUrl);

  useEffect(() => {
    const handleError = (error: unknown) => {
      if (isDevelopment) {
        console.error(error);
      } else {
        Sentry.captureException(error);
      }
    };

    window.addEventListener('error', (event) => handleError(event.error));
    window.addEventListener('unhandledrejection', (event) =>
      handleError(event.reason)
    );

    return () => {
      window.removeEventListener('error', (event) => handleError(event.error));
      window.removeEventListener('unhandledrejection', (event) =>
        handleError(event.reason)
      );
    };
  }, []);

  if (!user || !token) {
    return <></>;
  }

  return (
    <ConfigContextProvider>
      <UserContextProvider token={token} user={user}>
        <Layout className="app">
          <Switch>
            <Route path="/ext" component={ExtApp as React.ComponentType} />
            <Route
              path="/extranet"
              component={HotelApp as React.ComponentType}
            />
            <Route
              path="/hotel-migration"
              component={HotelMigrationApp as React.ComponentType}
            />
            <Route path="/public" component={PublicApp} />
            <Route path="/" component={AdminApp as React.ComponentType} />
          </Switch>
        </Layout>
      </UserContextProvider>
    </ConfigContextProvider>
  );
};
